import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "poster"]
const _hoisted_2 = ["src"]

import { ref, computed, reactive, onMounted } from 'vue'
import { ScrollOffset } from './types'
import { MJPSection, MJPSectionData } from '../magicjohnsonpark/types'
import { useEventBus } from '@vueuse/core'
import type { Ref } from 'vue'
import Hls from 'hls.js'

interface Props {
  manifest: string
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  scrollOffset: ScrollOffset
  loop?: boolean
  minPage?: number
  maxPage?: number
  dir: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveBackgroundVideo',
  props: {
    manifest: null,
    sectionData: null,
    currentSection: null,
    currentSectionHasLoaded: { type: Boolean },
    currentPage: null,
    scrollOffset: null,
    loop: { type: Boolean },
    minPage: null,
    maxPage: null,
    dir: null
  },
  setup(__props: any) {

const props = __props as {
  manifest: string
  sectionData: MJPSectionData
  currentSection: MJPSection
  currentSectionHasLoaded: boolean
  currentPage: number
  scrollOffset: ScrollOffset
  loop?: boolean
  minPage?: number
  maxPage?: number
  dir: string
}


const video: Ref<HTMLVideoElement | null> = ref(null)
const mediaLoadedBus = useEventBus('media-loaded')
const state = reactive({
  isPlaying: false,
  prefersReducedMotion: matchMedia('(prefers-reduced-motion)').matches,
})

const sectionIsActive = computed(() => {
  return props.currentSection == props.sectionData.section
})

const pageRangeIsActive = (lo, hi) => {
  if (sectionIsActive.value && props.currentSectionHasLoaded) {
    return props.currentPage >= lo && props.currentPage <= hi
  } else {
    return false
  }
}

const opacityForPageRange = (lo, hi) => {
  if (state.isPlaying) {
    return pageRangeIsActive(lo, hi) ? 1 : 0
  } else {
    return 0
  }
}

const handlePlay = (evt) => {
  state.isPlaying = true
}

const handlePause = (evt) => {
  state.isPlaying = false
}

const announceMediaLoaded = () => {
  mediaLoadedBus.emit({
    id: video.value?.getAttribute('id'),
    progress: 1.0,
  })
}

onMounted(() => {
  if (state.prefersReducedMotion) {
    announceMediaLoaded()
  } else if (video.value) {
    const config = {
      capLevelToPlayerSize: false,
      startLevel: 3,
    }
    let hls = new Hls(config)
    video.value.loop = props.loop ? props.loop : false
    hls.loadSource(props.manifest)
    hls.attachMedia(video.value)
    hls.on(Hls.Events.LEVEL_SWITCHED, function (result) {
      console.log('Level switched', hls.currentLevel)
    })
    hls.on(Hls.Events.MANIFEST_PARSED, function (result) {
      console.log(hls.config)
      announceMediaLoaded()
      video.value?.play()
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (!state.prefersReducedMotion)
    ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        ref_key: "video",
        ref: video,
        id: `${props.sectionData.section}-intro`,
        poster: `/images/${props.dir}/${props.sectionData.section}-video-start.jpg`,
        class: "tour-intro-video border-none absolute object-cover top-0 left-0 w-full h-full overflow-hidden",
        muted: "",
        autoplay: "",
        playsinline: "",
        style: _normalizeStyle({
      opacity: opacityForPageRange(props.minPage, props.maxPage),
      objectPosition: props.scrollOffset.proxyPosition,
    }),
        onPlay: handlePlay,
        onPause: handlePause
      }, [
        _createElementVNode("source", {
          src: props.manifest,
          type: "application/x-mpegURL"
        }, null, 8, _hoisted_2)
      ], 44, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})